<nz-spin [nzSpinning]="loadingPrefill" [nzTip]="(isBrandedDomainUpgrade ? 'UPGRADE_CONTRACT_MODAL.BRANDED_DOMAIN.LOADING' : 'UPGRADE_CONTRACT_MODAL.LOADING') | translate">
  <ng-container *ngIf="isBrandedDomainUpgrade; else genericUpgradeFlow">
    <ng-container *ngIf="businessInquirySubmitted; else brandedBusinessRequest">
      <nz-alert
        nzType="success"
        nzShowIcon
        [nzMessage]="'UPGRADE_CONTRACT_MODAL.BUSINESS_INQUIRY_SUCCESS_TITLE' | translate"
        [nzDescription]="'UPGRADE_CONTRACT_MODAL.BUSINESS_INQUIRY_SUCCESS_DETAIL' | translate"
        class="upgrade-contract-modal__alert"
      ></nz-alert>
      <div class="upgrade-contract-modal__actions">
        <button nz-button nzType="primary" type="button" (click)="close()">
          {{ 'COMMON.CLOSE' | translate }}
        </button>
      </div>
    </ng-container>
    <ng-template #brandedBusinessRequest>
      <nz-alert
        nzType="info"
        nzShowIcon
        [nzMessage]="'UPGRADE_CONTRACT_MODAL.BRANDED_DOMAIN.INFO' | translate"
        class="upgrade-contract-modal__alert"
      ></nz-alert>
      <div class="upgrade-contract-modal__plan-cards upgrade-contract-modal__plan-cards--business-only">
        <ng-container [ngTemplateOutlet]="businessPlanCard"></ng-container>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #genericUpgradeFlow>
  <ng-container *ngIf="hasPendingContract; else upgradeFlow">
    <nz-alert
      nzType="info"
      nzShowIcon
      [nzMessage]="'UPGRADE_CONTRACT_MODAL.PENDING_CONTRACT_INFO' | translate:{ date: pendingContractDateLabel }"
      class="upgrade-contract-modal__alert"
    ></nz-alert>
    <div class="upgrade-contract-modal__actions">
      <button nz-button nzType="default" type="button" (click)="downloadPendingContract()" *ngIf="pendingUpgrade?.billingDocumentId">
        {{ 'UPGRADE_CONTRACT_MODAL.DOWNLOAD_SIGNED_CONTRACT' | translate }}
      </button>
      <button nz-button nzType="primary" type="button" (click)="close()">
        {{ 'COMMON.CLOSE' | translate }}
      </button>
    </div>
  </ng-container>

  <ng-template #upgradeFlow>
  <ng-container *ngIf="!isSummaryVisible; else summaryState">
    <ng-container *ngIf="specialOfferSubmitted || businessInquirySubmitted; else contractFormState">
      <nz-alert
        nzType="success"
        nzShowIcon
        [nzMessage]="(businessInquirySubmitted ? 'UPGRADE_CONTRACT_MODAL.BUSINESS_INQUIRY_SUCCESS_TITLE' : 'UPGRADE_CONTRACT_MODAL.SPECIAL_OFFER_SUCCESS') | translate"
        [nzDescription]="businessInquirySubmitted
          ? ('UPGRADE_CONTRACT_MODAL.BUSINESS_INQUIRY_SUCCESS_DETAIL' | translate)
          : ('UPGRADE_CONTRACT_MODAL.SPECIAL_OFFER_SUCCESS_DETAIL_COUNT' | translate:{ count: specialOfferRequestedCount ?? 0 })"
        class="upgrade-contract-modal__alert"
      ></nz-alert>

      <div class="upgrade-contract-modal__actions">
        <button nz-button nzType="primary" type="button" (click)="close()">
          {{ 'COMMON.CLOSE' | translate }}
        </button>
      </div>
    </ng-container>

    <ng-template #contractFormState>
    <nz-alert
      nzType="info"
      nzShowIcon
      [nzMessage]="'UPGRADE_CONTRACT_MODAL.INFO' | translate"
      class="upgrade-contract-modal__alert"
    ></nz-alert>

    <form nz-form nzLayout="vertical" [formGroup]="form">
      <div class="upgrade-contract-modal__plan-cards">
        <div class="plan-card plan-card--pro plan-card--selected">
          <div class="plan-card__header">
            <h4>{{ 'PLAN.PRO' | translate }}</h4>
            <span class="plan-card__badge">{{ 'UPGRADE_CONTRACT_MODAL.PLAN.SELF_SERVICE_BADGE' | translate }}</span>
          </div>
          <p class="plan-card__description">{{ 'UPGRADE_CONTRACT_MODAL.PLAN.PRO_SELF_SERVICE_DESC' | translate }}</p>
          <div class="plan-card__pricing" *ngIf="hasProPricingInfo">
            <div class="plan-card__pricing-row" *ngIf="!isFlatCustomPricingMode">
              <span>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.PRO_PRICING_BASE' | translate:{ amount: formatMoney(basePackagePriceNetYear), included: baseIncludedObjects } }}<sup>*</sup></span>
            </div>
            <div class="plan-card__pricing-row" *ngIf="!isFlatCustomPricingMode">
              <span>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.PRO_PRICING_EXTRA_PROPERTIES' | translate:{ amount: formatMoney(propertyUnitPriceNetYear) } }}<sup>*</sup></span>
            </div>
            <div class="plan-card__pricing-row plan-card__pricing-row--highlight" *ngIf="isFlatCustomPricingMode">
              <span>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.PRO_PRICING_SPECIAL_OFFER' | translate:{ amount: formatMoney(propertyUnitPriceNetYear) } }}<sup>*</sup></span>
            </div>
            <div class="plan-card__pricing-row" *ngIf="isFlatCustomPricingMode">
              <span>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.PRO_PRICING_SPECIAL_OFFER_DETAIL' | translate }}</span>
            </div>
            <div class="plan-card__pricing-row">
              <span>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.PRO_PRICING_EXTRA_USERS' | translate:{ amount: formatMoney(pricePerAdditionalUserNetYear) } }}<sup>*</sup></span>
            </div>
          </div>
          <p class="plan-card__pricing-note" *ngIf="hasProPricingInfo">
            {{ 'UPGRADE_CONTRACT_MODAL.PLAN.PRICING_NET_NOTE' | translate }}
          </p>
        </div>

        <ng-container [ngTemplateOutlet]="businessPlanCard"></ng-container>
      </div>

      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.CONTRACT_START_DATE' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldError('contractStartDate') || undefined">
              <nz-date-picker formControlName="contractStartDate" nzFormat="yyyy-MM-dd" [nzDisabledDate]="disabledPastContractStartDates" class="upgrade-contract-modal__control"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.LEGAL_NAME' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldError('legalName') || undefined">
              <input nz-input formControlName="legalName" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.VAT_ID' | translate }}</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="vatId" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.ADDRESS' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldError('address') || undefined">
              <textarea nz-input formControlName="address" rows="3"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.REPRESENTATIVE_NAME' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldError('representativeName') || undefined">
              <input nz-input formControlName="representativeName" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.REPRESENTATIVE_ROLE' | translate }}</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="representativeRole" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.PRIMARY_ACCOUNT_EMAIL' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldError('primaryAccountEmail') || undefined">
              <input nz-input type="email" formControlName="primaryAccountEmail" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.BILLING_EMAIL' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldError('billingEmail') || undefined">
              <input nz-input type="email" formControlName="billingEmail" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="upgrade-contract-modal__section-title">{{ 'UPGRADE_CONTRACT_MODAL.SECTIONS.LICENSE' | translate }}</div>
      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.REQUESTED_MAX_PROPERTIES' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldError('requestedMaxProperties') || undefined">
              <nz-input-number
                formControlName="requestedMaxProperties"
                [nzMin]="10"
                [nzStep]="1"
                [nzPrecision]="0"
                class="upgrade-contract-modal__control"
              ></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label>{{ 'UPGRADE_CONTRACT_MODAL.FIELDS.ADDITIONAL_USERS_COUNT' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldError('additionalUsersCount') || undefined">
              <nz-input-number
                formControlName="additionalUsersCount"
                [nzMin]="0"
                [nzStep]="1"
                [nzPrecision]="0"
                class="upgrade-contract-modal__control"
              ></nz-input-number>
            </nz-form-control>
            <div class="upgrade-contract-modal__field-hint">
              {{ 'UPGRADE_CONTRACT_MODAL.FIELDS.ADDITIONAL_USERS_HINT' | translate }}
            </div>
          </nz-form-item>
        </div>
      </div>

      <nz-alert
        *ngIf="requiresSpecialOffer"
        nzType="warning"
        nzShowIcon
        [nzMessage]="'UPGRADE_CONTRACT_MODAL.SPECIAL_OFFER_COMBINED' | translate:{ threshold: specialOfferThreshold }"
        class="upgrade-contract-modal__alert"
      ></nz-alert>

      <nz-alert
        *ngIf="!requiresSpecialOffer && specialOfferThreshold"
        nzType="info"
        nzShowIcon
        [nzMessage]="'UPGRADE_CONTRACT_MODAL.SPECIAL_OFFER_HINT_STARTING_AT' | translate:{ threshold: specialOfferThreshold }"
        class="upgrade-contract-modal__alert"
      ></nz-alert>

      <label nz-checkbox formControlName="acceptedTerms" class="upgrade-contract-modal__checkbox">
        {{ 'UPGRADE_CONTRACT_MODAL.FIELDS.ACCEPT_TERMS' | translate }}
      </label>
      <div class="upgrade-contract-modal__checkbox-error" *ngIf="getFieldError('acceptedTerms')">
        {{ getFieldError('acceptedTerms') }}
      </div>

      <div class="upgrade-contract-modal__actions">
        <button nz-button nzType="default" type="button" (click)="close()" [disabled]="submitting">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button nz-button nzType="primary" type="button" (click)="submit()" [nzLoading]="submitting">
          {{ (requiresSpecialOffer ? 'UPGRADE_CONTRACT_MODAL.ASK_FOR_SPECIAL_OFFER' : 'UPGRADE_CONTRACT_MODAL.CREATE_DRAFT') | translate }}
        </button>
      </div>
    </form>
    </ng-template>
  </ng-container>

  <ng-template #summaryState>
    <div [formGroup]="form">
    <ng-container *ngIf="!isSigned; else signedState">
      <nz-alert
        [nzType]="(isExistingDraft || isReplacedDraft) ? 'warning' : 'success'"
        nzShowIcon
        [nzMessage]="(isReplacedDraft
          ? 'UPGRADE_CONTRACT_MODAL.REPLACED_DRAFT_MESSAGE'
          : (isExistingDraft ? 'UPGRADE_CONTRACT_MODAL.EXISTING_DRAFT_MESSAGE' : 'UPGRADE_CONTRACT_MODAL.SUCCESS_MESSAGE')) | translate"
        class="upgrade-contract-modal__alert"
      ></nz-alert>

      <div class="upgrade-contract-modal__summary-grid">
        <div class="upgrade-contract-modal__summary-card">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.REQUESTED_MAX_PROPERTIES' | translate }}</span>
          <strong>{{ summary?.requestedMaxProperties }}</strong>
        </div>
        <div class="upgrade-contract-modal__summary-card">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.UNIT_PRICE' | translate }}</span>
          <strong>{{ formatMoney(summary?.unitPriceNetYear) }} {{ summary?.currency }}</strong>
        </div>
        <div class="upgrade-contract-modal__summary-card">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.ADDITIONAL_USERS' | translate }}</span>
          <strong>{{ summary?.additionalUsersCount ?? 0 }}</strong>
        </div>
        <div class="upgrade-contract-modal__summary-card upgrade-contract-modal__summary-card--financial">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.TOTAL_NET' | translate }}</span>
          <strong>{{ formatMoney(summary?.totals?.totalNet) }} {{ summary?.currency }}</strong>
        </div>
        <div class="upgrade-contract-modal__summary-card upgrade-contract-modal__summary-card--financial">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.VAT_AMOUNT' | translate }}</span>
          <strong>{{ formatMoney(summary?.totals?.vatAmount) }} {{ summary?.currency }}</strong>
        </div>
        <div class="upgrade-contract-modal__summary-card upgrade-contract-modal__summary-card--financial">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.TOTAL_GROSS' | translate }}</span>
          <strong>{{ formatMoney(summary?.totals?.totalGross) }} {{ summary?.currency }}</strong>
        </div>
      </div>
      <div class="upgrade-contract-modal__field-hint upgrade-contract-modal__pricing-note" *ngIf="showFlatCustomPricingNote">
        {{ 'UPGRADE_CONTRACT_MODAL.PRICING_MODE_NOTE' | translate }}
      </div>

      <nz-alert
        nzType="info"
        nzShowIcon
        [nzMessage]="'UPGRADE_CONTRACT_MODAL.NOT_UPGRADED_YET' | translate"
        class="upgrade-contract-modal__alert"
      ></nz-alert>

      <nz-alert
        nzType="warning"
        nzShowIcon
        [nzMessage]="'UPGRADE_CONTRACT_MODAL.UNSIGNED_PREVIEW_INFO' | translate"
        class="upgrade-contract-modal__alert"
      ></nz-alert>

      <div class="upgrade-contract-modal__actions">
        <button nz-button nzType="default" type="button" (click)="goBackToForm()" class="upgrade-contract-modal__back-button">
          <span nz-icon nzType="arrow-left"></span>
          {{ 'UPGRADE_CONTRACT_MODAL.BACK_TO_EDIT' | translate }}
        </button>
        <button nz-button nzType="default" type="button" (click)="previewContract()" [nzLoading]="previewing">
          {{ 'UPGRADE_CONTRACT_MODAL.PREVIEW_CONTRACT' | translate }}
        </button>
        <button nz-button nzType="default" type="button" (click)="downloadPreviewContract()" [nzLoading]="downloadingPreview">
          {{ 'UPGRADE_CONTRACT_MODAL.DOWNLOAD_PDF' | translate }}
        </button>
      </div>

      <div class="upgrade-contract-modal__section-title">{{ 'UPGRADE_CONTRACT_MODAL.SIGN_SECTION_TITLE' | translate }}</div>
      <div class="upgrade-contract-modal__signature-panel">
        <label class="upgrade-contract-modal__signature-label">
          {{ 'UPGRADE_CONTRACT_MODAL.PLEASE_DRAW_SIGNATURE' | translate }}
        </label>
        <div class="upgrade-contract-modal__signature-hint">
          {{ 'UPGRADE_CONTRACT_MODAL.SIGNATURE_HINT' | translate }}
        </div>
        <div class="upgrade-contract-modal__signature-pad">
          <canvas
            #signatureCanvas
            class="upgrade-contract-modal__signature-canvas"
            (pointerdown)="beginSignature($event)"
            (pointermove)="drawSignature($event)"
            (pointerup)="endSignature($event)"
            (pointerleave)="endSignature($event)"
            (pointercancel)="endSignature($event)"
          ></canvas>
          <div class="upgrade-contract-modal__signature-placeholder" *ngIf="!hasSignature">
            {{ 'UPGRADE_CONTRACT_MODAL.SIGNATURE_PLACEHOLDER' | translate }}
          </div>
          <div class="upgrade-contract-modal__signature-line"></div>
        </div>
        <div class="upgrade-contract-modal__checkbox-error" *ngIf="signatureTouched && !hasSignature">
          {{ 'UPGRADE_CONTRACT_MODAL.SIGNATURE_REQUIRED' | translate }}
        </div>
        <div class="upgrade-contract-modal__signature-actions">
          <button nz-button nzType="default" type="button" (click)="clearSignature()">
            {{ 'UPGRADE_CONTRACT_MODAL.CLEAR_SIGNATURE' | translate }}
          </button>
        </div>
      </div>

      <div class="upgrade-contract-modal__signing-place">
        <label class="upgrade-contract-modal__signing-place-label">
          {{ 'UPGRADE_CONTRACT_MODAL.FIELDS.SIGNING_PLACE' | translate }}
        </label>
        <div class="upgrade-contract-modal__signing-place-control">
          <input nz-input formControlName="signingPlace" />
          <div class="upgrade-contract-modal__field-error">
            {{ getFieldError('signingPlace') || '' }}
          </div>
        </div>
      </div>

      <label nz-checkbox formControlName="acceptedFinalContract" class="upgrade-contract-modal__checkbox">
        {{ 'UPGRADE_CONTRACT_MODAL.FIELDS.ACCEPT_FINAL_CONTRACT' | translate }}
      </label>
      <div class="upgrade-contract-modal__checkbox-error" *ngIf="getFieldError('acceptedFinalContract')">
        {{ getFieldError('acceptedFinalContract') }}
      </div>

      <div class="upgrade-contract-modal__actions">
        <button nz-button nzType="default" type="button" (click)="close()" [disabled]="signing">
          {{ 'COMMON.CLOSE' | translate }}
        </button>
        <button nz-button nzType="primary" type="button" (click)="submitSignature()" [disabled]="!canSubmitSignature" [nzLoading]="signing">
          {{ 'UPGRADE_CONTRACT_MODAL.SIGN_CONTRACT' | translate }}
        </button>
      </div>
    </ng-container>

    <ng-template #signedState>
      <ng-container *ngIf="isPendingActivation; else immediateActivation">
        <nz-alert
          nzType="success"
          nzShowIcon
          [nzMessage]="('UPGRADE_CONTRACT_MODAL.PENDING_ACTIVATION_SUCCESS' | translate:{ date: activationDateLabel })"
          class="upgrade-contract-modal__alert"
        ></nz-alert>
        <nz-alert
          nzType="info"
          nzShowIcon
          [nzMessage]="'UPGRADE_CONTRACT_MODAL.PENDING_ACTIVATION_INFO' | translate"
          class="upgrade-contract-modal__alert"
        ></nz-alert>

        <div class="upgrade-contract-modal__summary-grid">
          <div class="upgrade-contract-modal__summary-item">
            <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.STATUS' | translate }}</span>
            <strong>{{ statusLabelKey(summary?.status) | translate }}</strong>
          </div>
          <div class="upgrade-contract-modal__summary-item">
            <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.CURRENT_PLAN' | translate }}</span>
            <strong>{{ planLabelKey(signedResult?.companyPlan) | translate }}</strong>
          </div>
          <div class="upgrade-contract-modal__summary-item">
            <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.PENDING_PLAN' | translate }}</span>
            <strong>{{ planLabelKey(signedResult?.pendingPlan) | translate }}</strong>
          </div>
          <div class="upgrade-contract-modal__summary-item">
            <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.CURRENT_MAX_PROPERTIES' | translate }}</span>
            <strong>{{ signedResult?.maxProperties }}</strong>
          </div>
          <div class="upgrade-contract-modal__summary-item">
            <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.PENDING_MAX_PROPERTIES' | translate }}</span>
            <strong>{{ signedResult?.pendingMaxProperties }}</strong>
          </div>
          <div class="upgrade-contract-modal__summary-item">
            <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.CURRENT_SEATS' | translate }}</span>
            <strong>{{ signedResult?.seatLimit ?? 0 }}</strong>
          </div>
          <div class="upgrade-contract-modal__summary-item">
            <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.PENDING_SEATS' | translate }}</span>
            <strong>{{ signedResult?.pendingSeatLimit }}</strong>
          </div>
          <div class="upgrade-contract-modal__summary-item">
            <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.ACTIVATION_DATE' | translate }}</span>
            <strong>{{ activationDateLabel }}</strong>
          </div>
        </div>

        <div class="upgrade-contract-modal__actions">
          <button nz-button nzType="default" type="button" (click)="downloadSignedContract()" [nzLoading]="downloadingSignedContract">
            {{ 'UPGRADE_CONTRACT_MODAL.DOWNLOAD_SIGNED_CONTRACT' | translate }}
          </button>
          <button nz-button nzType="primary" type="button" (click)="close()">
            {{ 'COMMON.CLOSE' | translate }}
          </button>
        </div>
      </ng-container>

      <ng-template #immediateActivation>
      <nz-alert
        nzType="success"
        nzShowIcon
        [nzMessage]="('UPGRADE_CONTRACT_MODAL.COMPANY_UPGRADED' | translate:{ plan: (planLabelKey(signedResult?.companyPlan) | translate) })"
        class="upgrade-contract-modal__alert"
      ></nz-alert>

      <div class="upgrade-contract-modal__summary-grid upgrade-contract-modal__summary-grid--success">
        <div class="upgrade-contract-modal__summary-card upgrade-contract-modal__summary-card--success">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.STATUS' | translate }}</span>
          <strong>{{ statusLabelKey(summary?.status) | translate }}</strong>
        </div>
        <div class="upgrade-contract-modal__summary-card upgrade-contract-modal__summary-card--success">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.TARGET_PLAN' | translate }}</span>
          <strong>{{ planLabelKey(signedResult?.companyPlan) | translate }}</strong>
        </div>
        <div class="upgrade-contract-modal__summary-card upgrade-contract-modal__summary-card--success">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.REQUESTED_MAX_PROPERTIES' | translate }}</span>
          <strong>{{ signedResult?.maxProperties }}</strong>
        </div>
        <div class="upgrade-contract-modal__summary-card upgrade-contract-modal__summary-card--success">
          <span>{{ 'UPGRADE_CONTRACT_MODAL.SUMMARY.TOTAL_SEATS_AFTER_UPGRADE' | translate }}</span>
          <strong>{{ signedResult?.seatLimit }}</strong>
        </div>
      </div>

      <div class="upgrade-contract-modal__actions">
        <button nz-button nzType="default" type="button" (click)="downloadSignedContract()" [nzLoading]="downloadingSignedContract">
          {{ 'UPGRADE_CONTRACT_MODAL.DOWNLOAD_SIGNED_CONTRACT' | translate }}
        </button>
        <button nz-button nzType="primary" type="button" (click)="close()">
          {{ 'COMMON.CLOSE' | translate }}
        </button>
      </div>
      </ng-template>
    </ng-template>
    </div>
  </ng-template>
  </ng-template>
  </ng-template>

  <ng-template #businessPlanCard>
    <div class="plan-card plan-card--business-cta">
      <div class="plan-card__header">
        <h4>{{ 'PLAN.BUSINESS' | translate }}</h4>
        <span class="plan-card__badge plan-card__badge--cta">{{ 'UPGRADE_CONTRACT_MODAL.PLAN.CUSTOM_QUOTE_BADGE' | translate }}</span>
      </div>
      <div class="plan-card__business-benefits">
        <p class="plan-card__cta-intro">{{ (isBrandedDomainUpgrade ? 'UPGRADE_CONTRACT_MODAL.BRANDED_DOMAIN.BUSINESS_CUSTOM_QUOTE' : 'UPGRADE_CONTRACT_MODAL.PLAN.BUSINESS_CUSTOM_QUOTE') | translate }}</p>
        <ul>
          <li>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.BENEFIT_INCLUDES_PRO' | translate }}</li>
          <li>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.BENEFIT_5_TEAM_ACCOUNTS' | translate }}</li>
          <li>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.BENEFIT_ACCOUNT_MANAGER' | translate }}</li>
          <li>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.BENEFIT_PRIORITY_SUPPORT' | translate }}</li>
          <li>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.BENEFIT_API_ACCESS' | translate }}</li>
          <li>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.BENEFIT_SLA' | translate }}</li>
          <li>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.BENEFIT_INTEGRATIONS' | translate }}</li>
          <li>{{ 'UPGRADE_CONTRACT_MODAL.PLAN.BENEFIT_WHITELABELING' | translate }}</li>
        </ul>
      </div>
      <button nz-button nzType="default" nzBlock type="button" (click)="submitBusinessInquiry()" [nzLoading]="businessInquirySubmitting">
        {{ 'UPGRADE_CONTRACT_MODAL.REQUEST_BUSINESS' | translate }}
      </button>
    </div>
  </ng-template>
</nz-spin>
